import { useLazyQuery } from 'apollo-3';
import { useMemo } from 'react';

import { getMPMyProgressTracker } from 'GraphQL/query/MyPath.query';

const useGetMyProgressTracker = (props) => {
  // NOTE: The date is needed to be memoized to prevent an infinite loop.
  const date = useMemo(() => {
    return new Date().toISOString();
  }, []);

  const [getMyProgressTracker, { data, loading, error, networkStatus, ...apolloUtils }] =
    useLazyQuery(getMPMyProgressTracker, {
      variables: { date },
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true,
      ...props,
    });

  return {
    getMyProgressTracker,
    mpMyProgressTracker: data?.mpMyProgressTracker,
    loading,
    error,
    ...apolloUtils,
  };
};

export default useGetMyProgressTracker;
